import { render, staticRenderFns } from "./Declare.vue?vue&type=template&id=490d03ba"
import script from "./Declare.vue?vue&type=script&lang=js"
export * from "./Declare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports